<button mat-raised-button class="btnRechazar" (click)="openDialog('rechazo')">Rechazar</button>
<button mat-raised-button *ngIf="puedeFirmar" class="btnAceptar" (click)="openDialog('firmar')">Firmar</button>